<template>

  <div
    class="border overflow-auto border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0">

    <div v-if="uiFlags.isFetchingTemplates" class="items-center flex text-base justify-center">
      <spinner color-scheme="primary" />
      <p>Loading form..</p>
    </div>

    <div v-else class="h-auto  flex flex-col w-[800px]">
      <woot-modal-header :header-title="$t('CAMPAIGN_MANAGER.ADD.TITLE')"
        :header-content="$t('CAMPAIGN_MANAGER.ADD.DESC')" />
      <div class="px-8 pt-8">
        <form class="flex flex-col w-full" @submit.prevent="addCampaignTemplate">
          <div class="w-full">
            <label :class="{ error: $v.templateID.$error }">
              {{ $t('CAMPAIGN_MANAGER.ADD.FORM.TEMPLATE.LABEL') }}
              <select name="templates"  v-model="templateID" @change="onChangeTemplate($event)">
                <option v-for="item in templates" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
              <span v-if="!templates.length" class="message">
                {{ $t('CAMPAIGN_MANAGER.ADD.FORM.TEMPLATE.NO_APPROVED') }}
              </span>
              <span v-if="$v.templateID.$error" class="message">
                {{ $t('CAMPAIGN_MANAGER.ADD.FORM.TEMPLATE.ERROR') }}
              </span>
            </label>

            <div class="grid grid-cols-2 gap-4">
              <div>
                <div v-if="campaing.templateVars && campaing.templateVars.length == 0">
                  No variables for template
                </div>
                <div v-if="campaing.templateMediaImage">
                  <label>
                    <span v-html="'{{' + 'Image' + '}}'"></span>
                    <div class="source-type-selector">
                      <label class="radio-inline"><input type="radio" value="column" :checked="getMediaSourceType('Image') === 'column'" @change="setMediaSourceType('Image', 'column')" /> {{ columnLabel }}</label>
                      <label class="radio-inline"><input type="radio" value="file" :checked="getMediaSourceType('Image') === 'file'" @change="setMediaSourceType('Image', 'file')" /> Upload File</label>
                    </div>
                    <select v-if="getMediaSourceType('Image') === 'column'" v-model="campaing.templateMediaImage.field">
                      <option v-for="(itemField, indexField ) in templateFieldList" :key="indexField + 1"
                        :value="itemField">
                        {{ itemField }}
                      </option>
                    </select>
                    <div v-if="getMediaSourceType('Image') === 'file'" class="file-upload-inline">
                      <input type="file" accept="image/*" @change="onMediaFileUpload($event, 'Image')" />
                      <span v-if="isUploadingMedia" class="upload-status">Uploading...</span>
                      <span v-if="campaing.templateMediaImage.field && getMediaSourceType('Image') === 'file'" class="upload-status upload-success">File uploaded</span>
                    </div>
                    <span
                      v-if="$v.campaing.templateMediaImage && $v.campaing.templateMediaImage.field && $v.campaing.templateMediaImage.field.$error"
                      class="message">
                      Valid field url for image required
                    </span>
                  </label>
                </div>

                <div v-if="campaing.templateMediaVideo">
                  <label>
                    <span v-html="'{{' + 'Video' + '}}'"></span>
                    <div class="source-type-selector">
                      <label class="radio-inline"><input type="radio" value="column" :checked="getMediaSourceType('Video') === 'column'" @change="setMediaSourceType('Video', 'column')" /> {{ columnLabel }}</label>
                      <label class="radio-inline"><input type="radio" value="file" :checked="getMediaSourceType('Video') === 'file'" @change="setMediaSourceType('Video', 'file')" /> Upload File</label>
                    </div>
                    <select v-if="getMediaSourceType('Video') === 'column'" v-model="campaing.templateMediaVideo.field">
                      <option v-for="(itemField, indexField ) in templateFieldList" :key="indexField + 1"
                        :value="itemField">
                        {{ itemField }}
                      </option>
                    </select>
                    <div v-if="getMediaSourceType('Video') === 'file'" class="file-upload-inline">
                      <input type="file" accept="video/*" @change="onMediaFileUpload($event, 'Video')" />
                      <span v-if="isUploadingMedia" class="upload-status">Uploading...</span>
                      <span v-if="campaing.templateMediaVideo.field && getMediaSourceType('Video') === 'file'" class="upload-status upload-success">File uploaded</span>
                    </div>
                    <span
                      v-if="$v.campaing.templateMediaVideo && $v.campaing.templateMediaVideo.field && $v.campaing.templateMediaVideo.field.$error"
                      class="message">
                      Valid field url for video required
                    </span>
                  </label>
                </div>

                <div v-if="campaing.templateMediaDocument">
                  <label>
                    <span v-html="'{{' + 'Document' + '}}'"></span>
                    <div class="source-type-selector">
                      <label class="radio-inline"><input type="radio" value="column" :checked="getMediaSourceType('Document') === 'column'" @change="setMediaSourceType('Document', 'column')" /> {{ columnLabel }}</label>
                      <label class="radio-inline"><input type="radio" value="file" :checked="getMediaSourceType('Document') === 'file'" @change="setMediaSourceType('Document', 'file')" /> Upload File</label>
                    </div>
                    <select v-if="getMediaSourceType('Document') === 'column'" v-model="campaing.templateMediaDocument.field"
                      @change="$v.campaing.templateMediaDocument.field.$touch">
                      <option v-for="(itemField, indexField ) in templateFieldList" :key="indexField + 1"
                        :value="itemField">
                        {{ itemField }}
                      </option>
                    </select>
                    <div v-if="getMediaSourceType('Document') === 'file'" class="file-upload-inline">
                      <input type="file" @change="onMediaFileUpload($event, 'Document')" />
                      <span v-if="isUploadingMedia" class="upload-status">Uploading...</span>
                      <span v-if="campaing.templateMediaDocument.field && getMediaSourceType('Document') === 'file'" class="upload-status upload-success">File uploaded</span>
                    </div>
                    <span
                      v-if="$v.campaing.templateMediaDocument && $v.campaing.templateMediaDocument.field && $v.campaing.templateMediaDocument.field.$error"
                      class="message">
                      Valid field url for document required
                    </span>
                  </label>
                </div>

                <h2 v-if="campaing.templateHeaderVars.length">Header Params</h2>
                <div v-for="(itemVar, index) in campaing.templateHeaderVars" :key="'header-' + index">
                  <div v-for="(value, key) in itemVar" :key="'header+' + key">
                    <label
                      :class="{ error: $v.campaing.templateHeaderVars[index] && $v.campaing.templateHeaderVars[index][key] && $v.campaing.templateHeaderVars[index][key].$error }">
                      <span v-html="'{{' + (key) + '}}'"></span>
                      <div class="source-type-selector">
                        <label class="radio-inline"><input type="radio" value="column" :checked="getParamSourceType('header', key) === 'column'" @change="setParamSourceType('header', key, 'column', index)" /> {{ columnLabel }}</label>
                        <label class="radio-inline"><input type="radio" value="static" :checked="getParamSourceType('header', key) === 'static'" @change="setParamSourceType('header', key, 'static', index)" /> Static Value</label>
                      </div>
                      <select v-if="getParamSourceType('header', key) === 'column'" v-model="campaing.templateHeaderVars[index][key]">
                        <option v-for="(itemField, indexField ) in templateFieldList" :key="'header-' + indexField + 1"
                          :value="itemField">
                          {{ itemField }}
                        </option>
                      </select>
                      <input v-if="getParamSourceType('header', key) === 'static'" type="text" v-model="campaing.templateHeaderVars[index][key]" placeholder="Enter static value" />
                      <span
                        v-if="$v.campaing.templateHeaderVars[index] && $v.campaing.templateHeaderVars[index][key] && $v.campaing.templateHeaderVars[index][key].$error"
                        class="message">
                        Field required
                      </span>
                    </label>
                  </div>
                </div>





                <h2 v-if="campaing.templateVars.length">Body Params</h2>
                <div v-for="(itemVar, index) in campaing.templateVars" :key="index">
                  <div v-for="(value, key) in itemVar" :key="key">
                    <label
                      :class="{ error: $v.campaing.templateVars[index] && $v.campaing.templateVars[index][key] && $v.campaing.templateVars[index][key].$error }">
                      <span v-html="'{{' + (key) + '}}'"></span>
                      <div class="source-type-selector">
                        <label class="radio-inline"><input type="radio" value="column" :checked="getParamSourceType('body', key) === 'column'" @change="setParamSourceType('body', key, 'column', index)" /> {{ columnLabel }}</label>
                        <label class="radio-inline"><input type="radio" value="static" :checked="getParamSourceType('body', key) === 'static'" @change="setParamSourceType('body', key, 'static', index)" /> Static Value</label>
                      </div>
                      <select v-if="getParamSourceType('body', key) === 'column'" v-model="campaing.templateVars[index][key]">
                        <option v-for="(itemField, indexField ) in templateFieldList" :key="indexField + 1"
                          :value="itemField">
                          {{ itemField }}
                        </option>
                      </select>
                      <input v-if="getParamSourceType('body', key) === 'static'" type="text" v-model="campaing.templateVars[index][key]" placeholder="Enter static value" />
                      <span
                        v-if="$v.campaing.templateVars[index] && $v.campaing.templateVars[index][key] && $v.campaing.templateVars[index][key].$error"
                        class="message">
                        Field required
                      </span>
                    </label>
                  </div>
                </div>

             
                <h2 v-if="campaing.templateButtonsVars.length">Buttons Params</h2>
                <div v-for="(itemVar, index) in campaing.templateButtonsVars" :key="index+'button'">
                  <div v-for="(value, key) in itemVar" :key="key">
                    <label
                      :class="{ error: $v.campaing.templateButtonsVars[index] && $v.campaing.templateButtonsVars[index][key] && $v.campaing.templateButtonsVars[index][key].$error }">
                      <span v-html="'{{'+ (key) + '}}'"></span>
                      <div class="source-type-selector">
                        <label class="radio-inline"><input type="radio" value="column" :checked="getParamSourceType('buttons', key) === 'column'" @change="setParamSourceType('buttons', key, 'column', index)" /> {{ columnLabel }}</label>
                        <label class="radio-inline"><input type="radio" value="static" :checked="getParamSourceType('buttons', key) === 'static'" @change="setParamSourceType('buttons', key, 'static', index)" /> Static Value</label>
                      </div>
                      <select v-if="getParamSourceType('buttons', key) === 'column'" v-model="campaing.templateButtonsVars[index][key]">
                        <option v-for="(itemField, indexField ) in templateFieldList" :key="indexField + 1"
                          :value="itemField">
                          {{ itemField }}
                        </option>
                      </select>
                      <input v-if="getParamSourceType('buttons', key) === 'static'" type="text" v-model="campaing.templateButtonsVars[index][key]" placeholder="Enter static value" />
                      <span
                        v-if="$v.campaing.templateButtonsVars[index] && $v.campaing.templateButtonsVars[index][key] && $v.campaing.templateButtonsVars[index][key].$error"
                        class="message">
                        Field required
                      </span>
                    </label>
                  </div>
                </div>


              </div>
              <div>
                <label>Template preview</label>
                <div class="chat-container">
                  <div class="received" v-html="templateMessage">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
            <woot-button type="button" variant="clear" @click.prevent="previous">
              << Previous </woot-button>
                <woot-button :is-loading="uiFlags.isCreating">
                  Next >>
                </woot-button>

          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import useVuelidate from '@vuelidate/core'
import { required } from 'vuelidate/lib/validators';
import Spinner from 'shared/components/Spinner.vue';
import alertMixin from 'shared/mixins/alertMixin';
import campaignMixin from 'shared/mixins/campaignMixin';
import ContactAPI from 'dashboard/api/contacts';
import {
  validateCampaignMediaFileSize,
  campaignMediaMaxSizeLabelMb,
} from 'dashboard/helper/buildCampaignOutboundParams';

export default {
  components: {
    Spinner
  },

  mixins: [alertMixin, campaignMixin],
  data() {
    return {
      show: true,
      enabled: true,
      segmentSampleContact: null,
      segmentSampleLoading: false,
      segmentSampleError: '',
      isUploadingMedia: false,
    };
  },
  validations() {
    const templateVarsValidations = {}

    this.campaing.templateVars.forEach((obj, index) => {
      Object.keys(obj).forEach(key => {
        templateVarsValidations[index] = {
          [key]: { required }
        }
      })
    })

    const templateHeaderVarsValidations = {}

    this.campaing.templateHeaderVars.forEach((obj, index) => {
      Object.keys(obj).forEach(key => {
        templateHeaderVarsValidations[index] = {
          [key]: { required }
        }
      })
    })

    const templateButtonsVarsValidations = {}

    this.campaing.templateButtonsVars.forEach((obj, index) => {
      Object.keys(obj).forEach(key => {
        templateButtonsVarsValidations[index] = {
          [key]: { required }
        }
      })
    })

    const mediaSourceTypes = (this.campaing.paramSourceTypes && this.campaing.paramSourceTypes.media) || {};

    const templateMediaValidations = {
      templateMediaVideo: this.campaing.templateMediaVideo ? {
        field: mediaSourceTypes['Video'] === 'file' ? {
          required,
          isHttpsUrl: value => {
            const urlPattern = /^https:\/\/[^ "]+$/;
            return urlPattern.test(value);
          },
        } : {
          required, isHttpsUrl: value => {
            const urlPattern = /^https:\/\/[^ "]+$/;
            return urlPattern.test(this.templateSampleData[value]);
          },
          isVideoLoaded: value => {
            return new Promise(resolve => {
              const video = document.createElement('video');
              video.onloadeddata = () => resolve(true);
              video.onerror = () => resolve(false);
              video.src = this.templateSampleData[value];
            });
          }
        },
      } : {},
      templateMediaImage: this.campaing.templateMediaImage ? {
        field: mediaSourceTypes['Image'] === 'file' ? {
          required,
          isHttpsUrl: value => {
            const urlPattern = /^https:\/\/[^ "]+$/;
            return urlPattern.test(value);
          },
        } : {
          required,
          isHttpsUrl: value => {
            const urlPattern = /^https:\/\/[^ "]+$/;
            return urlPattern.test(this.templateSampleData[value]);
          },
          isLoaded: value => {
            return new Promise(resolve => {
              const img = new Image();
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
              img.src = this.templateSampleData[value];
            });
          },
        },
      } : {},
      templateMediaDocument: this.campaing.templateMediaDocument ? {
        field: mediaSourceTypes['Document'] === 'file' ? {
          required,
          isHttpsUrl: value => {
            const urlPattern = /^https:\/\/[^ "]+$/;
            return urlPattern.test(value);
          },
        } : {
          required, isHttpsUrl: value => {
            const urlPattern = /^https:\/\/[^ "]+$/;
            return urlPattern.test(this.templateSampleData[value]);
          }
        },
      } : {},
    };

    return {
      templateID: {
        required,
      },
      campaing: {
        templateVars: { ...templateVarsValidations },
        templateHeaderVars: { ...templateHeaderVarsValidations },
        templateButtonsVars: { ...templateButtonsVarsValidations },
        ...templateMediaValidations
      },
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'campaignsManager/getUIFlags',
      campaing: 'campaignsManager/getCampaign',
      templates: 'campaignsManager/getTemplates',
      excelTemplateSampleData: 'campaignsManager/getTemplateSampleData'

    }),
    audienceSource() {
      return this.campaing?.audienceSource || 'excel';
    },
    segmentId() {
      return this.campaing?.segmentId;
    },
    templateSampleData() {
      if (this.audienceSource !== 'segment') return this.excelTemplateSampleData;
      if (!this.segmentSampleContact) return {};

      const contact = this.segmentSampleContact;
      const sample = {
        id: contact.id,
        name: contact.name,
        email: contact.email,
        phone_number: contact.phone_number,
        identifier: contact.identifier,
      };

      const additional = contact.additional_attributes || {};
      Object.keys(additional).forEach(key => {
        sample[`additional_attributes.${key}`] =
          additional[key] === null || additional[key] === undefined
            ? ''
            : additional[key].toString();
      });

      const custom = contact.custom_attributes || {};
      Object.keys(custom).forEach(key => {
        sample[`custom_attributes.${key}`] =
          custom[key] === null || custom[key] === undefined
            ? ''
            : custom[key].toString();
      });

      return sample;
    },
    templateFieldList() {
      return Object.keys(this.templateSampleData)
    },
    columnLabel() {
      return this.audienceSource === 'segment' ? 'Contact Field' : 'Excel Column';
    },
    templates() {
      return this.$store.getters['campaignsManager/getTemplateList'].filter(template => template.status === "APPROVED");
    },
    templateID: {
      get() {
        let campaing = this.$store.getters['campaignsManager/getCampaign'];
        return campaing.templateID
      },
      set(value) {
        this.$store.dispatch('campaignsManager/updateTemplateID', value);
      }
    },
    selectedTemplate() {
      return this.templates.filter((item) => {
        return item.id == this.templateID
      })

    },
    templateMessage() {

      let selectedTemplate = this.$store.getters['campaignsManager/getSelectedTemplate']
      let strTamplate = "";
      const mediaSourceTypes = (this.campaing.paramSourceTypes && this.campaing.paramSourceTypes.media) || {};
      const headerSourceTypes = (this.campaing.paramSourceTypes && this.campaing.paramSourceTypes.header) || {};
      const bodySourceTypes = (this.campaing.paramSourceTypes && this.campaing.paramSourceTypes.body) || {};

      if (selectedTemplate) {

        let components = selectedTemplate.components
        if (components) {
          components.forEach(component => {
            switch (component.type) {
              case "HEADER":

                strTamplate += `<div class="message header">`

                if (component.format == "TEXT") {
                  strTamplate += `<div class="text"> ${component.text}</div>`

                  this.campaing.templateHeaderVars.forEach((varItem) => {
                    let varNumbers = Object.keys(varItem);
                    varNumbers.forEach((number) => {
                      const isStatic = headerSourceTypes[number] === 'static';
                      const resolvedValue = isStatic ? varItem[number] : this.templateSampleData[varItem[number]];
                      if (resolvedValue) {
                        strTamplate = strTamplate.replace(`{{${number}}}`, "<b>" + resolvedValue + "</b>")
                      }
                    })
                  })
                }

                if (component.format == "VIDEO") {

                  if (this.campaing.templateMediaVideo.field) {

                    const videoUrl = mediaSourceTypes['Video'] === 'file'
                      ? this.campaing.templateMediaVideo.field
                      : this.templateSampleData[this.campaing.templateMediaVideo.field];

                    strTamplate += `<div class="video">
                                        <video width="400" controls>
                                          <source src="${videoUrl}" type="video/mp4">
                                          Your browser does not support HTML video.
                                        </video>
                                    </div>`

                  } else {
                    strTamplate += `<div class="video">
                                      <img src="${this.getNoVideoURL}" />
                                    </div>`
                  }
                }

                if (component.format == "IMAGE") {

                  const isFileSource = mediaSourceTypes['Image'] === 'file';
                  const imageUrl = isFileSource
                    ? this.campaing.templateMediaImage.field
                    : this.templateSampleData[this.campaing.templateMediaImage.field];

                  const urlPattern = /^https:\/\/[^ "]+$/;
                  let isURL = urlPattern.test(imageUrl);


                  let isLoaded = new Promise(resolve => {
                    const img = new Image();
                    img.onload = () => resolve(true);
                    img.onerror = () => resolve(false);
                    img.src = imageUrl;
                  });


                  if (this.campaing.templateMediaImage.field && isURL && isLoaded) {

                    strTamplate += `<div class="image">
                                      <img src="${imageUrl}" />
                                    </div>`

                  } else {
                    strTamplate += `<div class="image">
                                      <img src="${this.getNoImageURL}" />
                                    </div>`
                  }
                }

                if (component.format == "DOCUMENT") {

                  if (this.campaing.templateMediaDocument.field) {

                    const isDocFileSource = mediaSourceTypes['Document'] === 'file';
                    let documentUrl = isDocFileSource
                      ? this.campaing.templateMediaDocument.field
                      : this.templateSampleData[this.campaing.templateMediaDocument.field];
                    let fileName = documentUrl.substring(documentUrl.lastIndexOf('/') + 1);

                    strTamplate += `<div class="document"> 
                                    <div class="file-preview-container">
        <div class="document-part"></div>
        <div class="file-preview">
            <div class="file-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#25D366" width="40px" height="40px">
                    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 14h-8v-2h8v2zm0-4h-8v-2h8v2zm-3-5V3.5L18.5 9H13z"></path>
                </svg>
            </div>
            <div class="file-details">
                <a href="https://example.com/document.pdf" class="file-name" target="_blank">${fileName}</a>
               
            </div>
        </div>
    </div>
                                    </div>`



                  } else {
                    strTamplate += `<div class="document"> 
                                    <div class="file-preview-container">
        <div class="document-part"></div>
        <div class="file-preview">
            <div class="file-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#D5D5D5" width="40px" height="40px">
                    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 14h-8v-2h8v2zm0-4h-8v-2h8v2zm-3-5V3.5L18.5 9H13z"></path>
                </svg>
            </div>
            <div class="file-details">
                <a href="#" class="file-name" target="_blank">document.pdf</a>
                <span class="file-size">200 KB</span>
            </div>
        </div>
    </div>
                                    </div>`
                  }
                }
                strTamplate += `</div>`


                break;
              case "BODY":
                strTamplate += `<div class="message body"> ${component.text}</div>`
                this.campaing.templateVars.forEach((varItem) => {
                  let varNumbers = Object.keys(varItem);
                  varNumbers.forEach((number) => {
                    const isStatic = bodySourceTypes[number] === 'static';
                    const resolvedValue = isStatic ? varItem[number] : this.templateSampleData[varItem[number]];
                    if (resolvedValue) {
                      strTamplate = strTamplate.replace(`{{${number}}}`, "<b>" + resolvedValue + "</b>")
                    }
                  })
                })

                break;
              case "BUTTONS":
                
                 strTamplate += `<div class="buttons">`;
                  
                    component.buttons.forEach((button, index) => {
                    if(button.type=="URL" && button.url.includes('{{1}}')){

                        

                        let url = button.url.replace('{{1}}', '');
                        

                        strTamplate += `<button type="button" class="chat-button"> <a href="${url}#{{${index}}}" target="_blank"> ${button.text}</a></button>`;
                      
                   

                    }else{
                      strTamplate += `<button type="button" class="chat-button">${button.text}</button>`
                    }
                  })
                strTamplate += `</div>`

                  const buttonSourceTypes = (this.campaing.paramSourceTypes && this.campaing.paramSourceTypes.buttons) || {};
                  this.campaing.templateButtonsVars.forEach((varItem) => {
                    let varNumbers = Object.keys(varItem);
                    varNumbers.forEach((number) => {
                      const isBtnStatic = buttonSourceTypes[number] === 'static';
                      const resolvedBtnValue = isBtnStatic ? varItem[number] : this.templateSampleData[varItem[number]];
                      if (resolvedBtnValue) {
                        strTamplate = strTamplate.replace(`#{{${number}}}`, resolvedBtnValue)
                      }
                    })
                  })





                break;

              default:
                console.log("");
            }
          });

        }

      }




      return strTamplate
    },
    getNoImageURL() {
      const BotImage = require('dashboard/assets/images/no-photo.jpg');
      return BotImage
    },
    getNoVideoURL() {
      const BotImage = require('dashboard/assets/images/no-video.gif');
      return BotImage
    },
    getNoDocumentURL() {
      const BotImage = require('dashboard/assets/images/no-document.jpg');
      return BotImage
    },
    previous() {
      this.$router.push({
        name: 'campaigns_new'
      });
    },
  },
  mounted() {

    let params = {}
    this.$store.dispatch('campaignsManager/getTemplates', params);

    this.v$ = useVuelidate();
    if (this.audienceSource === 'segment') {
      this.fetchSegmentSampleContact();
    }

  },
  watch: {
    // Watch para detectar cambios en campaing.templateVars
    'campaing.templateVars': {
      handler() {
        console.log(this.campaing.templateVars)
        this.$v.$reset(); // Reiniciar las validaciones
        this.v$ = useVuelidate(); // Volver a inicializar Vuelidate con la nueva configuración
      },
      deep: true,
      immediate: true
    },
    'campaing.templateHeaderVars': {
      handler() {
        console.log(this.campaing.templateHeaderVars)
        this.$v.$reset(); // Reiniciar las validaciones
        this.v$ = useVuelidate(); // Volver a inicializar Vuelidate con la nueva configuración
      },
      deep: true,
      immediate: true
    },
    audienceSource(newVal) {
      if (newVal === 'segment') {
        this.fetchSegmentSampleContact();
      } else {
        this.segmentSampleContact = null;
        this.segmentSampleError = '';
        this.segmentSampleLoading = false;
      }
    },
    segmentId() {
      if (this.audienceSource === 'segment') {
        this.fetchSegmentSampleContact();
      }
    }
  },
  methods: {
    async fetchSegmentSampleContact() {
      if (!this.segmentId) return;
      this.segmentSampleLoading = true;
      this.segmentSampleError = '';
      try {
        const { data } = await ContactAPI.getSegmentContacts(this.segmentId, {
          page: 1,
          include_contact_inboxes: false,
          sort: '-last_activity_at',
        });
        this.segmentSampleContact = Array.isArray(data?.payload)
          ? data.payload[0]
          : null;

        if (this.segmentSampleContact) {
          const contact = this.segmentSampleContact;
          const sample = {
            id: contact.id,
            name: contact.name,
            email: contact.email,
            phone_number: contact.phone_number,
            identifier: contact.identifier,
          };

          const additional = contact.additional_attributes || {};
          Object.keys(additional).forEach(key => {
            sample[`additional_attributes.${key}`] =
              additional[key] === null || additional[key] === undefined
                ? ''
                : additional[key].toString();
          });

          const custom = contact.custom_attributes || {};
          Object.keys(custom).forEach(key => {
            sample[`custom_attributes.${key}`] =
              custom[key] === null || custom[key] === undefined
                ? ''
                : custom[key].toString();
          });

          this.$store.commit(
            'campaignsManager/setSegmentTemplateSampleData',
            sample
          );
        } else {
          this.$store.commit('campaignsManager/setSegmentTemplateSampleData', {});
        }
      } catch (e) {
        this.segmentSampleError =
          e?.response?.data?.message ||
          e?.message ||
          'Could not load a sample contact for this segment';
        this.segmentSampleContact = null;
        this.$store.commit('campaignsManager/setSegmentTemplateSampleData', {});
      } finally {
        this.segmentSampleLoading = false;
      }
    },
    getInvalidFields() {
      const invalidFields = [];

      console.log(this.$v.campaing.templateVars)

      /*
            this.$v.campaing.templateVars.forEach((validationObj, index) => {
              for (const key in validationObj) {
                if (!validationObj[key].$pending && validationObj[key].$invalid) {
                  invalidFields.push({ index, key });
                }
              }
            });*/

      return null;
    },
    onClose() {
      this.$emit('on-close');
    },
    onChange(value) {
      this.scheduledAt = value;
    },
    async onChangeTemplate() {
      this.$store.dispatch('campaignsManager/updateTemplateVars', this.templateID);
    },
    getParamSourceType(category, key) {
      const sources = this.campaing.paramSourceTypes || {};
      return (sources[category] && sources[category][key]) || 'column';
    },
    getMediaSourceType(mediaType) {
      const sources = this.campaing.paramSourceTypes || {};
      return (sources.media && sources.media[mediaType]) || 'column';
    },
    setParamSourceType(category, key, sourceType, index) {
      this.$store.dispatch('campaignsManager/updateParamSourceType', { category, key, sourceType });
      // Reset the value when switching source type
      if (category === 'body' && this.campaing.templateVars[index]) {
        this.$set(this.campaing.templateVars[index], key, '');
      } else if (category === 'header' && this.campaing.templateHeaderVars[index]) {
        this.$set(this.campaing.templateHeaderVars[index], key, '');
      } else if (category === 'buttons' && this.campaing.templateButtonsVars[index]) {
        this.$set(this.campaing.templateButtonsVars[index], key, '');
      }
    },
    setMediaSourceType(mediaType, sourceType) {
      this.$store.dispatch('campaignsManager/updateParamSourceType', { category: 'media', key: mediaType, sourceType });
      // Reset the field value when switching source type
      if (mediaType === 'Image' && this.campaing.templateMediaImage) {
        this.$set(this.campaing.templateMediaImage, 'field', '');
      } else if (mediaType === 'Video' && this.campaing.templateMediaVideo) {
        this.$set(this.campaing.templateMediaVideo, 'field', '');
      } else if (mediaType === 'Document' && this.campaing.templateMediaDocument) {
        this.$set(this.campaing.templateMediaDocument, 'field', '');
      }
    },
    async onMediaFileUpload(event, mediaType) {
      const file = event.target.files[0];
      if (!file) return;
      const sizeCheck = validateCampaignMediaFileSize(mediaType, file);
      if (!sizeCheck.ok) {
        this.showAlert(
          `File exceeds WhatsApp media limit for ${mediaType.toLowerCase()} (${campaignMediaMaxSizeLabelMb(
            mediaType
          )} MB max).`
        );
        event.target.value = '';
        return;
      }
      this.isUploadingMedia = true;
      try {
        const fileUrl = await this.$store.dispatch('campaignsManager/uploadMediaFile', file);
        if (mediaType === 'Image' && this.campaing.templateMediaImage) {
          this.$set(this.campaing.templateMediaImage, 'field', fileUrl);
        } else if (mediaType === 'Video' && this.campaing.templateMediaVideo) {
          this.$set(this.campaing.templateMediaVideo, 'field', fileUrl);
        } else if (mediaType === 'Document' && this.campaing.templateMediaDocument) {
          this.$set(this.campaing.templateMediaDocument, 'field', fileUrl);
        }
      } catch (error) {
        this.showAlert('Error uploading file. Please try again.');
      } finally {
        this.isUploadingMedia = false;
      }
    },

    async addCampaignTemplate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$router.push({
        name: 'campaigns_schedule'
      });

    },
    onDragOver(event) {
      this.isDragover = true;
    },
    onDragLeave(event) {
      this.isDragover = false;
    },
    onDrop(event) {
      this.isDragover = false;
      const files = event.dataTransfer.files;
      this.handleFiles(files);
    },
    onFileChange(event) {
      const files = this.$refs.fileInput.files;
      this.handleFiles(files);
    },
    handleFiles(files) {
      console.log('Files dropped:', files);
      // Aquí puedes procesar los archivos como desees
    },


  },

};
</script>


<style lang="scss">
.chat-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  margin: auto;
  padding: 10px 10px 20px 10px;
  background-color: #e5ddd5;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  min-height: 400px;
  justify-content: end;

}

.chat-container .message {

  max-width: 100%;
  margin: 10px 0 0 0;
  padding: 10px;
  border-radius: 10px;
  position: relative;
  word-wrap: break-word;
  background-color: #fff;
  font-size: 14px;
}

.chat-container .message.received {
  align-self: flex-start;
  background-color: #fff;
}

.chat-container .message p {
  margin: 0;
  font-size: 14px;
  color: #333;
}

.chat-container .message .time {
  align-self: flex-end;
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.message.received::before {
  content: '';
  position: absolute;
  bottom: 10px;
  left: -10px;
  width: 0;
  height: 0;
  border-right: 10px solid #fff;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.chat-container .message .buttons {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

}

.chat-container .buttons .chat-button {
  background-color: #fff;
  color: #007bff;
  border: 0;
  border-radius: 5px;
  padding: 8px;
  margin: 5px 0 0 0;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s, color 0.3s;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}



.buttons .chat-button:focus {
  outline: none;
}

.file-preview-container {
  position: relative;
}

.document-part {

  width: 100%;
  height: 100px;
  background-color: #fff;

  border-radius: 5px 5px 0 0;
}

.file-preview {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

  z-index: 1;
  position: relative;
}

.file-icon {
  margin-right: 15px;
}

.file-details {
  text-align: left;
}

.file-name {
  font-weight: bold;
  color: #007BFF;
  text-decoration: none;
  display: block;
}

.file-name:hover {
  text-decoration: underline;
}

.file-size {
  color: #666;
  font-size: 14px;
}

.source-type-selector {
  display: flex;
  gap: 12px;
  margin: 4px 0 6px 0;
}

.source-type-selector .radio-inline {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: normal;
  cursor: pointer;
  margin: 0;
}

.source-type-selector .radio-inline input[type="radio"] {
  margin: 0;
  cursor: pointer;
}

.file-upload-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.file-upload-inline input[type="file"] {
  font-size: 13px;
}

.upload-status {
  font-size: 12px;
  color: #666;
}

.upload-status.upload-success {
  color: #25D366;
  font-weight: 500;
}
</style>